import { render, staticRenderFns } from "./assignForm.vue?vue&type=template&id=50bfcbe6&"
import script from "./assignForm.vue?vue&type=script&lang=js&"
export * from "./assignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports